export default __webpack_public_path__ + "static/media/LEVEL20.c5858e27.png";